import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_SEND_EMAIL;

function filter(param = {}) {
  return wsService.make_post_request(section + "/filter", param);
}

function create(params) {
  return wsService.make_post_request(section + "/create", params);
}

function getLastSentEmail(client_id, type = 'voucher') {
  return wsService.make_post_request(section + "/get_last_sent_email", { client_id, type });
}

export const sendEmailService = {
  filter,
  create,
  getLastSentEmail,
};
